import insightAreaItemConnector from "../insight-area-item-connector"
import InsightAreaEditItem from "./InsightAreaEditItem"

export default insightAreaItemConnector(InsightAreaEditItem)
